module.exports = __webpack_public_path__ + "static/media/marathon newspaper 2.03d893c6.jpg";